import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Card, CardBody, Col, Container, Row, FormGroup, Alert, Label, Input, InputGroup, InputGroupText, } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import XLSX from 'xlsx';
import { calculatorApi } from '../../services/CalculatorService';

import Breadcrumbs from '../../components/Breadcrumb';
import PageLoader from '../../components/Loaders/newPageLoader';
import useLoadingProgress from '../../hooks/useLoadingProgress';
import { showToast } from '../../components/Toast';
import { MainContent } from '../../components/Table/MainContent';

export default function InfoList({ profileData, loading }) {
  const {
    data = [],
    isLoading,
    isFetching,
    error,
    refetch
  } = calculatorApi.useFetchAllDataQuery(undefined, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false
  });
  const [ addNewCountries ] = calculatorApi.useAddNewCountriesMutation();

  const [destinations, setDestinationsData] = useState([]);
  const [fedexPrices, setFedexPricesData] = useState([]);
  const [emsPrices, setEmsPricesData] = useState([]);
  const [agents, setAgentsData] = useState([]);
  const [agentFees, setAgentFeesData] = useState([]);
  const [boxSizes, setBoxSizesData] = useState([]);
  const [countriesTrs, setCountriesTrsData] = useState([]);
  const [taxPrices, setTaxPricesData] = useState([]);
  const [variables, setVariablesData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [box, setSelectedBox] = useState([]);
  const [variable, setSelectedVariable] = useState([]);
  const [activeTab, setActiveTab] = useState(1);

  const { progress, step, visible } = useLoadingProgress({ isLoading, isFetching });
  useEffect(() => {
    if (data.destinations) {
      setDestinationsData(JSON.parse(JSON.stringify(data.destinations)));
      setFedexPricesData(JSON.parse(JSON.stringify(data.fedexPrices)));
      setEmsPricesData(JSON.parse(JSON.stringify(data.emsPrices)));
      setAgentsData(JSON.parse(JSON.stringify(data.agents)));
      setAgentFeesData(JSON.parse(JSON.stringify(data.agentFees)));
      setBoxSizesData(JSON.parse(JSON.stringify(data.boxSizes)));
      setCountriesTrsData(JSON.parse(JSON.stringify(data.countriesTrs)));
      setTaxPricesData(JSON.parse(JSON.stringify(data.taxPrices)));
      setVariablesData(JSON.parse(JSON.stringify(data.variables)));
    }
  }, [data]);

  const [cardHeight, setCardHeight] = useState(0);
  const cardRef = useRef(null);
  useEffect(() => {
    if (!cardRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        if (newHeight > 0) setCardHeight(newHeight);
      }
    });
    resizeObserver.observe(cardRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  const [filters, setNoDbFilters ] = useState([]);
  const [filteredDestinations, setFilteredDestinations] = useState([]);
  const [filteredEmsPrices, setFilteredEmsPrices] = useState([]);
  const [filteredFedexPrices, setFilteredFedexPrices] = useState([]);

  useEffect(() => {
    const applyFilters = () => {
      let result = [...destinations];
      let resultEms = [...emsPrices];
      let resultFedex = [...fedexPrices];

      if (filters?.countriesFrom?.length > 0) {
        result = result.filter(destination => filters?.countriesFrom.includes(destination.countryFrom));
        resultEms = resultEms.filter(ems => filters?.countriesFrom.includes(ems.country));
        resultFedex = resultFedex.filter(fedex => filters?.countriesFrom.includes(fedex.country));
      }
      if (filters?.countriesTo?.length > 0) {
        result = result.filter(destination => filters?.countriesTo.includes(destination.countryTo));
      }

      setFilteredDestinations(result);
      setFilteredEmsPrices(resultEms);
      setFilteredFedexPrices(resultFedex);
    };

    applyFilters();
  }, [filters, destinations, emsPrices, fedexPrices]);  

  const [modalNewBox, setModalNewBox] = useState(false);
  const toggleModalNewBox = useCallback(() => {
    setModalNewBox((prev) => !prev);
  }, []);
  const handleNewBoxClick = () => {
    setSelectedBox([]);
    // setAccessSelectedUser([]);
    setIsEdit(false);
    toggleModalNewBox();
  };
  const modalNewBoxSizeContent = (
    <>
      <Row>
        <Col md={6}>
          <FormGroup className='mb-3'>
            <AvField
              name='boxSizeNo'
              label='Box Size'
              type='number'
              errorMessage='Invalid Size'
              validate={{
                required: {
                  value: true
                }
              }}
              value={box.boxSizeNo || ''}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup className='mb-3'>
            <AvField
              name='volWeight'
              label='Volume Weight'
              type='number'
              errorMessage='Invalid weight'
              validate={{
                required: {
                  value: true
                }
              }}
              value={box.volWeight || ''}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className='mb-3'>
            <AvField
              name='length'
              label='Length'
              value={box.length || ''}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className='mb-3'>
            <AvField
              name='width'
              label='Width'
              value={box.width || ''}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className='mb-3'>
            <AvField
              name='height'
              label='Height'
              value={box.height || ''}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
  const handleNewUserSubmit = async (e, values) => {
    if (isEdit) {
      const updateBoxSize = {
        _id: box._id,
        boxSizeNo: values.boxSizeNo,
        width: values.width,
        length: values.length,
        height: values.height,
        volWeight: values.volWeight
      };
      try {
        // await updateUser(updateBoxSize).unwrap();
        toggleModalNewBox();
        showToast('Box is Updated');
      } catch (error) {
        console.error('Failed to Update Box:', error);
        showToast('Failed to Update Box Information', 'error');
      }
    } else {
      const newBoxSize = {
        boxSizeNo: values['boxSizeNo'],
        width: values['width'],
        length: values['length'],
        height: values['height'],
        volWeight: values['volWeight']
      };
      try {
        // await addUser(newBoxSize).unwrap();
        toggleModalNewBox();
        showToast('New Box is Added');
      } catch (error) {
        console.error('Failed to add new Box:', error);
        showToast('Failed to Add New Box', 'error');
      }
    }
  };

  const handleClickEditBoxSize = (boxSize) => {
    setSelectedBox(boxSize);
    setIsEdit(true);
    toggleModalNewBox();
  };

  const [rowToDelete, setRowToDelete] = useState(null);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);

  const handleBoxSizeClickDelete = (boxSize) => {
    setSelectedBox(boxSize);
    setRowToDelete(boxSize._id);
    setShowDeleteAlert(true);
  };

  const handleDeleteBoxSize = async () => {
    try {
      // setIsDeleting(true);
      // await deleteUser(rowToDelete);
      setRowToDelete(null);
      setShowDeleteAlert(false);
      setSelectedBox([]);
      showToast('User deleted successfully');
    } catch (error) {
      console.error('Failed to delete row:', error);
      showToast('Failed to delete row', 'error');
    }
  };  

  const boxSizesColumns = [
    {
      text: 'ID',
      dataField: '_id',
      sort: true,
      editable: false,
      hidden: true,
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      text: 'Box Size',
      dataField: 'box',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, boxSize) => (
        <h5 className='font-size-16 mb-1'>
          {boxSize.boxSizeNo}
          <i className='bx bx-chevron-down-square ms-1' />
        </h5>
      )
    },
    {
      text: 'Length',
      dataField: 'length',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, boxSize) => (
        <h5 className='font-size-16 mb-1 '>{boxSize.length}cm</h5>
      )
    },
    {
      text: 'Width',
      dataField: 'width',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, boxSize) => (
        <h5 className='font-size-16 mb-1 '>{boxSize.width}cm</h5>
      )
    },
    {
      text: 'Height',
      dataField: 'height',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, boxSize) => (
        <h5 className='font-size-16 mb-1 '>{boxSize.height}cm</h5>
      )
    },
    {
      text: 'Weight',
      dataField: 'volWeight',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, boxSize) => (
        <h5 className='font-size-16 mb-1 '>{boxSize.volWeight}kg</h5>
      )
    },
    {
      dataField: 'menu',
      text: 'Action',
      editable: false,
      formatter: (cellContent, boxSize) => (
        <div className='d-flex gap-3 text-right'>
          {profileData.permissions.includes('shippingTableEdit') && (
            <>
              <Link className='text-success' to='#'>
                <i
                  className='mdi mdi-pencil font-size-18'
                  id='edittooltip'
                  onClick={(e) => handleClickEditBoxSize(boxSize)}
                ></i>
              </Link>
              <Link className='text-danger' to='#'>
                <i
                  className='mdi mdi-delete font-size-18'
                  id='deletetooltip'
                  onClick={() => handleBoxSizeClickDelete(boxSize)}
                ></i>
              </Link>
            </>
          )}
        </div>
      )
    }
  ]
  const emsPricesColumns = [
    {
      text: 'ID',
      dataField: '_id',
      sort: true,
      editable: false,
      hidden: true,
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      text: 'Country',
      dataField: 'country',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, emsPrice) => (
        <h5 className='font-size-16 mb-1 '>{emsPrice.country}</h5>
      )
    },
    {
      text: 'Net Weight',
      dataField: 'netWeightEms',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, emsPrice) => (
        <h5 className='font-size-16 mb-1 '>{emsPrice.netWeightEms} kg</h5>
      )
    },
    {
      text: 'Price Amount',
      dataField: 'priceAmountEms',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, emsPrice) => (
        <h5 className='font-size-16 mb-1 '>{emsPrice.priceAmountEms}$</h5>
      )
    }
  ]
  const fedexPricesColumns = [
    {
      text: 'ID',
      dataField: '_id',
      sort: true,
      editable: false,
      hidden: true,
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      text: 'Country',
      dataField: 'country',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, fedexPrice) => (
        <h5 className='font-size-16 mb-1 '>{fedexPrice.country}</h5>
      )
    },
    {
      text: 'Net Weight',
      dataField: 'netWeight',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, fedexPrice) => (
        <h5 className='font-size-16 mb-1 '>{fedexPrice.netWeightFedex} kg</h5>
      )
    },
    {
      text: 'Price Amount',
      dataField: 'priceAmount',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, fedexPrice) => (
        <h5 className='font-size-16 mb-1 '>{fedexPrice.priceAmountFedex}$</h5>
      )
    }
  ]

  const variablesColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: (cellContent, variable) => <>{variable._id}</>,
    },
    {
      text: "Variable Name",
      dataField: "variableName",
      formatter: (cellContent, variable) => (
        <h5 className="font-size-16 mb-1">{variable.variableName}</h5>
      ),
    },
    {
      text: "Variable Value",
      dataField: "variableValue",
      sort: true,
      formatter: (cellContent, variable) => (
        <h5 className="font-size-16 mb-1">{variable.variableValue}</h5>
      ),
    }
  ]
  const destinationsColumns = [
    {
      text: 'ID',
      dataField: '_id',
      sort: true,
      editable: false,
      hidden: true,
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      text: 'Box',
      dataField: 'box',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, destination) => (
        <h5 className='font-size-16 mb-1 '>
          {destination.box} <i className='bx bx-chevron-down-square ms-1' />
        </h5>
      )
    },
    {
      text: 'Country From',
      dataField: 'countryFrom',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, destination) => (
        <h5 className='font-size-16 mb-1 '>{destination.countryFrom}</h5>
      )
    },
    {
      text: 'Country To',
      dataField: 'countryTo',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, destination) => (
        <h5 className='font-size-16 mb-1 '>{destination.countryTo}</h5>
      )
    },
    {
      text: 'Cheap',
      dataField: 'cheapPr',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, destination) => (
        <h5 className='font-size-16 mb-1 '>{destination.cheapPr}</h5>
      )
    },
    {
      text: 'Exp',
      dataField: 'expPr',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, destination) => (
        <h5 className='font-size-16 mb-1 '>{destination.expPr}</h5>
      )
    }
  ]
  const defaultSorted = [
    {
      dataField: '_id', // if dataField is not match to any column you defined, it will be ignored.
      order: 'asc' // desc or asc
    }
  ];

  const countriesOptionsFrom = [...new Set(destinations.map(d => d.countryFrom))] // distinct countryFrom
    .sort((a, b) => a.localeCompare(b)) // sort alphabetically
    .map((name, index) => ({
      key: name,       // you could also use name if you want unique keys
      label: name,
      icon: '',
      colorClass: 'bg-primary'
    }));
  const countriesOptionsTo = [...new Set(destinations.map(d => d.countryTo))] // distinct countryFrom
    .sort((a, b) => a.localeCompare(b)) // sort alphabetically
    .map((name, index) => ({
      key: name,       // you could also use name if you want unique keys
      label: name,
      icon: '',
      colorClass: 'bg-primary'
    }));
  const filterFormValues = { countriesFrom: ['France'] }

  const filterFormSubmit = (e, values) => {
    // const { onAddNewEmsPrices, onAddNewCountries, onAddNewPrices, onAddNewTaxPrices } = this.props;
    for (let i = 0; i < selectedFileData.length; i++) {
      let importArr = [];
      //ADD Cheap and Exp PRICE
      importArr.push(
        {
          box: 1,
          countryFrom: selectedFileData[i][7],
          countryTo: selectedFileData[i][0],
          cheapPr: selectedFileData[i][1].split('/')[0],
          expPr: selectedFileData[i][1].split('/')[1]
        },
        {
          box: 2,
          countryFrom: selectedFileData[i][7],
          countryTo: selectedFileData[i][0],
          cheapPr: selectedFileData[i][2].split('/')[0],
          expPr: selectedFileData[i][2].split('/')[1]
        },
        {
          box: 3,
          countryFrom: selectedFileData[i][7],
          countryTo: selectedFileData[i][0],
          cheapPr: selectedFileData[i][3].split('/')[0],
          expPr: selectedFileData[i][3].split('/')[1]
        },
        {
          box: 4,
          countryFrom: selectedFileData[i][7],
          countryTo: selectedFileData[i][0],
          cheapPr: selectedFileData[i][4].split('/')[0],
          expPr: selectedFileData[i][4].split('/')[1]
        },
        {
          box: 5,
          countryFrom: selectedFileData[i][7],
          countryTo: selectedFileData[i][0],
          cheapPr: selectedFileData[i][5].split('/')[0],
          expPr: selectedFileData[i][5].split('/')[1]
        },
        {
          box: 6,
          countryFrom: selectedFileData[i][7],
          countryTo: selectedFileData[i][0],
          cheapPr: selectedFileData[i][6].split('/')[0],
          expPr: selectedFileData[i][6].split('/')[1]
        }
      );
      // onAddNewEmsPrices(importArr[0]);
      // onAddNewPrices(importArr[0]);
      // onAddNewTaxPrices(importArr[0]);
      console.log('importArr', importArr);
      addNewCountries(importArr);
      // onAddNewCountries(importArr);
    }
  };
  const [selectedFileData, setSelectedFileData] = useState([]);

  const handleExcelImportChange = (e, values) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    let countries = [];
    reader.onload = (event) => {
      //parse data
      const bstr = event.target.result;
      const workBook = XLSX.read(bstr, { type: 'binary' });
      //get first sheet
      const workSheetName = workBook.SheetNames[0];
      const workSheet = workBook.Sheets[workSheetName];
      const fileData = XLSX.utils.sheet_to_json(workSheet, {
        header: 1,
        raw: false
      });
      // fileData.splice(0, 1);
      setSelectedFileData(fileData)
    };
    reader.readAsBinaryString(file);
  };
  const filterCustomContent = (
    <>
      <FormGroup className='me-2'>
        <Label for='file-upload' className='custom-file-upload'>
          <i className='mdi mdi-file-import-outline label-icon'></i>
          Import CSV data
        </Label>
        <AvField type='file' name='excel' id='file-upload' onChange={handleExcelImportChange} />
      </FormGroup>
      <FormGroup className='me-2'>
        <button className='btn btn-success save-user'>Import</button>
      </FormGroup>
    </>
  );
  return (
    <React.Fragment>
      <PageLoader progress={progress} step={step} visible={visible} />
      <div className='page-content'>
        <MetaTags>
          <title>Shipping Information</title>
        </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('shippingCalcAccess') ? (
              <>
              <Breadcrumbs title='Calculator' breadcrumbItem='Shipping Information' />
              <div id='card-section' ref={cardRef}>
                <Row id='card-section'>
                  <Col lg='4'>
                    <Card>
                      <CardBody className='cardBodySticky'>
                        <ToolkitProvider
                          keyField='_id'
                          columns={destinationsColumns}
                          data={filteredDestinations.length > 0 ? filteredDestinations : destinations}
                          search
                        >
                          {(props) => (
                            <React.Fragment>
                              <MainContent
                                page={{ 
                                  pg: 'shipping_info', 
                                  props: props,
                                  cardHeight, 
                                  showSearch: false, 
                                  showCSV: false, 
                                  showInTblFltr: true, 
                                  showDbFilter: false, 
                                  showBtn: false, 
                                  columns: props.baseProps.columns,
                                  data: props.baseProps.data,
                                  defaultSorted
                                }}
                                filterOptions={{ countriesFrom: countriesOptionsFrom, countriesTo: countriesOptionsTo  }}
                                // filterDbOptions={{ filterFormValues, singleSelect: true, allowToggleSingle: true} }
                                filterDbOptions={{ filterFormValues, singleSelect: true, allowToggleSingle: true, filterCustomContent, filterFormSubmit }}
                                setNoDbFilters={setNoDbFilters}
                              />
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg='4'>
                    <div className='pcss3t logtb pcss3t-effect-scale pcss3t-theme-1'>
                      <input type='radio' name='pcss3t' id='emsTab' checked={activeTab === 1} onChange={() => setActiveTab(1)} className='tab-content-1' />
                      <label htmlFor='emsTab'>
                        <i className='mdi mdi-account-multiple'></i>EMS
                      </label>
                      <input type='radio' name='pcss3t' id='emsFedex' checked={activeTab === 2} onChange={() => setActiveTab(2)} className='tab-content-2' />
                      <label htmlFor='emsFedex'>
                        <i className='mdi mdi-calendar'></i>Fedex
                      </label>
                      <ul>
                        <AnimatePresence exitBeforeEnter>
                          <motion.li
                            className='tab-content tab-content-1 typography'
                            initial={{ opacity: 0, x: 30 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -30 }}
                            transition={{ duration: 0.3 }}
                            style={{ display: activeTab ? 'block' : 'none' }}
                          >
                            <div id='card-section' ref={cardRef}>
                              <Row className='card-section'>
                                <Col lg='12'>
                                  <Card>
                                    <CardBody className='cardBodySticky'>
                                    {activeTab && !isLoading && emsPricesColumns && (
                                      <ToolkitProvider
                                        keyField='_id'
                                        columns={emsPricesColumns}
                                        data={filteredEmsPrices.length > 0 ? filteredEmsPrices : emsPrices}
                                        search
                                      >
                                        {(props) => (
                                          <React.Fragment>
                                            <MainContent
                                              page={{ 
                                                pg: 'shipping_info', 
                                                props: props,
                                                cardHeight, 
                                                showSearch: false, 
                                                showCSV: false, 
                                                showInTblFltr: false, 
                                                showDbFilter: false, 
                                                showBtn: false, 
                                                columns: props.baseProps.columns,
                                                data: props.baseProps.data,
                                                defaultSorted
                                              }}
                                            />
                                          </React.Fragment>
                                        )}
                                      </ToolkitProvider>
                                    )}
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            </div>
                          </motion.li>
                        </AnimatePresence>
                        <AnimatePresence exitBeforeEnter>
                          <motion.li
                            className='tab-content tab-content-2 typography'
                            initial={{ opacity: 0, x: 30 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -30 }}
                            transition={{ duration: 0.3 }}
                            style={{ display: activeTab ? 'block' : 'none' }}
                          >
                            <div id='card-section' ref={cardRef}>
                              <Row className='card-section'>
                                <Col lg='12'>
                                  <Card>
                                    <CardBody className='cardBodySticky'>
                                    {activeTab && !isLoading && fedexPricesColumns && (
                                      <ToolkitProvider
                                        keyField='_id'
                                        columns={fedexPricesColumns}
                                        data={filteredFedexPrices.length > 0 ? filteredFedexPrices : fedexPrices}
                                        search
                                      >
                                        {(props) => (
                                          <React.Fragment>
                                            <MainContent
                                              page={{ 
                                                pg: 'shipping_info', 
                                                props: props,
                                                cardHeight, 
                                                showSearch: false, 
                                                showCSV: false, 
                                                showInTblFltr: false, 
                                                showDbFilter: false, 
                                                showBtn: false, 
                                                columns: props.baseProps.columns,
                                                data: props.baseProps.data,
                                                defaultSorted
                                              }}
                                            />
                                          </React.Fragment>
                                        )}
                                      </ToolkitProvider>
                                    )}
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            </div>
                          </motion.li>
                        </AnimatePresence>
                      </ul>
                    </div>      
                  </Col>
                  <Col lg='4'>
                    <Card className="shipping-info-height">
                      <CardBody className='cardBodySticky'>
                        <ToolkitProvider
                          keyField='_id'
                          columns={boxSizesColumns}
                          data={boxSizes}
                          search
                        >
                          {(props) => (
                            <React.Fragment>
                              <MainContent
                                page={{ 
                                  pg: 'shipping_info', 
                                  props: props,
                                  cardHeight, 
                                  showSearch: false, 
                                  showCSV: false, 
                                  showInTblFltr: false, 
                                  showDbFilter: false, 
                                  showBtn: true, 
                                  columns: props.baseProps.columns,
                                  data: props.baseProps.data,
                                  defaultSorted,
                                }}
                                // options for adding/updating modal and button
                                btnCrtModalOptions={{ 
                                  btnLabelCrt: 'Add New Box Size',
                                  modalSize:'md',
                                  modalTitle: isEdit ? 'Edit Box Size' : 'Add New Box Size',
                                  modalBtnLabel: isEdit ? 'Edit Box Size' : 'Add New Box Size',
                                  modalAdd: modalNewBox,
                                  toggleAddModal: toggleModalNewBox,
                                  handleNewClick: handleNewBoxClick,
                                  modalContent: modalNewBoxSizeContent,
                                  handleSubmit: handleNewUserSubmit,
                                }}
                              />
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      </CardBody>
                    </Card>
                    <Card className="shipping-info-height">
                      <CardBody className='cardBodySticky'>
                        <ToolkitProvider
                          keyField='_id'
                          columns={variablesColumns}
                          data={variables}
                          search
                        >
                          {(props) => (
                            <React.Fragment>
                              <MainContent
                                page={{ 
                                  pg: 'shipping_info', 
                                  props: props,
                                  cardHeight, 
                                  showSearch: false, 
                                  showCSV: false, 
                                  showInTblFltr: false, 
                                  showDbFilter: false, 
                                  showBtn: false, 
                                  columns: props.baseProps.columns,
                                  data: props.baseProps.data,
                                  defaultSorted,
                                }}
                              />
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      </CardBody>
                    </Card>
                  </Col>
                  <SweetAlert
                    show={showDeleteAlert}
                    danger
                    showCancel
                    confirmBtnText='Yes, delete it!'
                    confirmBtnBsStyle='danger'
                    title='Are you sure?'
                    onConfirm={handleDeleteBoxSize}
                    onCancel={() => setShowDeleteAlert(false)}
                    focusCancelBtn
                  >
                    <p className='fw-bold'>{box.boxSizeNo}</p>{' '}
                    will be deleted from the system!
                  </SweetAlert>
                </Row>
              </div>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
      </div>
    </React.Fragment>
  );
}